// @ts-nocheck
import React, { useState } from 'react';
import { useAuth } from '../../App';
import { Search, Bell, ChevronDown, LogOut, Menu } from 'lucide-react';

const Header = ({ onMenuClick, isMobile }) => {
  const { user, org, role, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-gray-200 h-16">
      <div className="h-full px-4 sm:px-6 flex items-center justify-between gap-4">
        {/* Left section */}
        <div className="flex items-center gap-3 flex-1">
          {/* Mobile Menu Button */}
          {isMobile && (
            <button
              onClick={onMenuClick}
              className="lg:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors"
              aria-label="Toggle menu"
            >
              <Menu size={20} className="text-gray-700" />
            </button>
          )}

          {/* Organization Name */}
          <div className="hidden sm:flex items-center gap-2">
            <h1 className="text-lg font-semibold text-gray-900 truncate">
              {org?.name || 'My Organization'}
            </h1>
            {role && (
              <span className="text-xs font-medium px-2 py-0.5 bg-cyan-100 text-cyan-700 rounded-full uppercase">
                {role}
              </span>
            )}
          </div>
        </div>

        {/* Right section */}
        <div className="flex items-center gap-2 sm:gap-3">
          {/* Search - Hidden on small mobile */}
          <div className="hidden md:flex items-center bg-gray-50 rounded-lg px-3 py-2 flex-1 max-w-md">
            <Search size={18} className="text-gray-400 mr-2" />
            <input
              type="text"
              placeholder="Search inventory, batches, orders..."
              className="bg-transparent border-none outline-none text-sm text-gray-700 placeholder-gray-400 w-full"
            />
          </div>

          {/* Notifications */}
          <button className="relative p-2 hover:bg-gray-100 rounded-lg transition-colors">
            <Bell size={20} className="text-gray-600" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>

          {/* User menu */}
          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center gap-2 sm:gap-3 hover:bg-gray-100 rounded-lg px-2 sm:px-3 py-2 transition-colors"
            >
              <div className="w-8 h-8 rounded-full bg-cyan-600 flex items-center justify-center text-white font-semibold text-sm">
                {user?.name?.charAt(0) || 'U'}
              </div>
              <span className="hidden sm:block text-sm font-medium text-gray-700 max-w-[120px] truncate">
                {user?.name || 'User'}
              </span>
              <ChevronDown size={16} className="hidden sm:block text-gray-500" />
            </button>

            {/* Dropdown */}
            {showUserMenu && (
              <>
                <div
                  className="fixed inset-0 z-10"
                  onClick={() => setShowUserMenu(false)}
                />
                <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-20">
                  <div className="px-4 py-3 border-b border-gray-100">
                    <p className="text-sm font-medium text-gray-900 truncate">{user?.name}</p>
                    <p className="text-xs text-gray-500 truncate">{user?.email}</p>
                    {org && (
                      <p className="text-xs text-gray-500 mt-1 truncate">{org.name}</p>
                    )}
                  </div>
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                  >
                    <LogOut size={16} />
                    Sign out
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
